<template>
  <div class="ui-readonly-field">
    <div class="ui-readonly-field__label body-1 mb-1 d-flex align-center">
      <slot name="label">{{ labelText }}</slot>
    </div>
    <div class="ui-readonly-field__value subtitle-2 text-break">
      <slot>{{ displayValue }}</slot>
    </div>
  </div>
</template>

<script>
// CPA-3558: read-only view of a form field (same look as the read-only fields on the player page)
export default {
  name: 'ui-readonly-field',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number, Array, Boolean],
      default: null,
    },
  },
  computed: {
    // required-field marker means nothing when the field can't be edited
    labelText() {
      return (this.label || '').replace(/\s*\*$/, '')
    },
    displayValue() {
      if (Array.isArray(this.value)) return this.value.filter(v => v !== '' && v != null).join(', ') || '-'
      if (typeof this.value === 'boolean') return this.$t(this.value ? 'base.yes' : 'base.no')
      return this.value === '' || this.value == null ? '-' : this.value
    },
  },
}
</script>

<style lang="scss">
.ui-readonly-field {
  min-width: 0;

  &__label {
    min-height: 20px;
  }

  &--multiline &__value {
    white-space: pre-line;
  }
}

// inputs often get a background class (e.g. `white`) for the editable state — the text view stays transparent
// (Vuetify sets it as `.v-application .white { ... !important }`)
.v-application .ui-readonly-field.white {
  background-color: transparent !important;
}
</style>
